<div class="modal-header">
    <h4 class="modal-title">{{ news?.title }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
  </div>
  <div class="modal-body">
    <p>{{ news?.message }}</p>
  </div>
  <div class="modal-footer justify-content-center">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close('Close click')">Chiudi</button>
  </div>